'use client';

import Box from '../../../atoms/Box/Box';
import Button from '../../../atoms/Button/Button';
import type { ButtonField } from '../types';
import type { FieldValues } from 'react-hook-form';
import styles from '../Form.module.scss';

export type ButtonControlProps = {
  field: ButtonField;
  theme: 'dark' | 'light';
  watchedValues: FieldValues;
  onSubmit: () => void;
};

/**
 * Form control for single button fields
 * @component
 * @param {ButtonControlProps} props - Component props
 * @returns {JSX.Element} Button control component
 */
const ButtonControl = ({ field, watchedValues, onSubmit }: ButtonControlProps) => {
  const handleButtonClick = async () => {
    if (field.onClick) {
      // Custom onClick: pass current form values, let handler decide what to do
      await field.onClick(watchedValues);
    } else {
      // Default: validate and submit form
      onSubmit();
    }
  };

  return (
    <Box className={styles[field.align ? field.align : 'center']} key={`form_field_${field.id}`}>
      <Button
        label={field.label}
        color={field.color}
        theme={field.theme}
        size={field.size}
        type={field.variant}
        handleClick={handleButtonClick}
        gaComponent=""
        dataTestId={`button-${field.id}`}
      />
    </Box>
  );
};

export default ButtonControl;
